import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import React from 'react';
import { Modal } from 'react-bootstrap';

type CustomModalProps = {
  show: boolean;
  heading: string | React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  children: React.ReactNode;
  saveButton?: string;
  buttonDisable?: boolean;
  icon?: React.ReactNode;
  modalStyle?: React.CSSProperties;
  staticBackdrop?: boolean;
};

export default function CustomModal({
  show,
  heading,
  onClose,
  onConfirm,
  children,
  saveButton,
  buttonDisable,
  icon,
  modalStyle,
  staticBackdrop = true,
}: CustomModalProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop={staticBackdrop ? 'static' : true}
      keyboard={!staticBackdrop}
      style={modalStyle}
    >
      <Modal.Header closeButton closeVariant="white" className="gap-3">
        {icon}
        <Modal.Title>{heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {saveButton && onConfirm && (
        <Modal.Footer>
          <div className="button-group">
            <StylishNewButton
              type="button"
              className="button--secondary button--reverse"
              onClick={onClose}
            >
              Close
            </StylishNewButton>
            <StylishNewButton
              type="button"
              className="button--primary"
              onClick={onConfirm}
              disabled={buttonDisable ? true : false}
            >
              {saveButton}
            </StylishNewButton>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}
